import {
  AdminPermissionArea,
  AdminPermissions,
} from '@/features/auth/auth.type';

export const deriveAdminPermissionsFromRolesArray = (
  orgId: string,
  roles: string[],
): AdminPermissions => {
  return {
    application: roles.includes(
      constructAdminRole(orgId, 'application'),
    ),
    index: roles.includes(constructAdminRole(orgId, 'index')),
    model: roles.includes(constructAdminRole(orgId, 'model')),
    sub: roles.includes(constructAdminRole(orgId, 'sub')),
    user: roles.includes(constructAdminRole(orgId, 'user')),
  };
};

const constructAdminRole = (
  orgId: string,
  area: AdminPermissionArea,
) => `org-${orgId}-${area}-admin`;
